import { Component, computed, inject } from '@angular/core';
import {
  RegionFilterDto,
  RegionItemDto,
  RegionService,
} from '@artemis-software/wr-api';
import { currentTenantId } from '@/utils/admin-utils';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { CurrentUserService } from '@services/current-user.service';

@Component({
  standalone: false,
  selector: 'wr-region-overview-page',
  templateUrl: './region-overview-page.component.html',
  styleUrls: ['./region-overview-page.component.scss']
})
export class RegionOverviewPageComponent {
  regionService = inject(RegionService);
  currentUserService = inject(CurrentUserService);
  tenantId = currentTenantId();
  canCreate = computed(() => this.currentUserService.hasPrivilege('canCreateRegions'));

  readonly loadRegions = (filter: RegionFilterDto) => this.regionService.findAll({ ...filter, tenantId: this.tenantId() });
  readonly getCount = (filter: RegionFilterDto) => this.regionService.getCount({ ...filter, tenantId: this.tenantId() });

  form!: FormGroup;

  constructor(private readonly router: Router,
              private readonly formBuilder: FormBuilder,)
  {
    this.form = this.formBuilder.group({
      text: this.formBuilder.control(''),
    });
  }

  navigateToRegion(region: RegionItemDto): void {
    this.router.navigate(['region', region.id]);
  }

  add(): void {
    this.router.navigate(['region', 'new']);
  }
}
